import React from 'react';

interface MemoizedCardStackProps {
  children: React.ReactNode;
}

// Keeps the card subtree isolated from unrelated page-level state changes.
// It intentionally renders no additional DOM element, so layout and visuals
// remain exactly the same.
const MemoizedCardStack = React.memo(({ children }: MemoizedCardStackProps) => <>{children}</>);

export default MemoizedCardStack;
